module.exports = __webpack_public_path__ + "static/media/subscription3.4e94781c.jpg";